import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=484c544e&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=484c544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c544e",
  null
  
)

export default component.exports